export default "__VITE_ASSET__8efe4cd3__"